<!-- PDF & Data Templte Exports -->
function prepareExportForm(el) {
    SC.PIM.Product.Bind.modal(el, function() {

        let pimProductIds = getProductIds();
        let ids = getOrderedIds(pimProductIds);

        let productCount = ids.length;

        if (productCount > 0 && productCount <= maximumUIExports) {

            let form = 'display-' + $(el).data('form') + '-form';
            let type = $(el).data('type');

            showModal()
            loadExportImageModal(form, type, ids);

        } else if (productCount === 0) {
            alert("Please select products.");
        } else {
            alert("This feature only supports up to " + maximumUIExports + " records at this time (You selected " + productCount + "). Please use Tags and Categories, along with the 'Export As' option from the main navigation for larger datasets.");
        }
    });
}

<!-- PDF & Data Templte Exports -->
$(function() {

    $("#pim-download-csv").click(function () {
        pimDownloadAsset('csv')
    });
    $("#pim-download-xls").click(function () {
        pimDownloadAsset('xls')
    });
    $("#pim-download-xml").click(function () {
        pimDownloadAsset('xml')
    });

    $(document).on('click', '.new_pim_export_as', function () {

        let pimProductIds = getProductIds();
        let ids = getOrderedIds(pimProductIds);

        let productCount = ids.length;

        if (productCount  === 0) {
            alert("Please select products.");
            return;
        }

        let form = 'display-' + $(this).data('form') + '-form';
        let type = $(this).data('type');
        let template = $(this).data('template');
        let name = $(this).data('name');

        if ((productCount <= maxPostFields && type == 'pdf') || (productCount <= maximumUIExports)) {
            showModal();
            loadExportDataPdfModal(form, type, ids, template, name)
        } else {
            alert("This feature only supports up to " + maximumUIExports + " records at this time (You selected " + productCount + "). Please use Tags and Categories, along with the 'Export As' option from the main navigation for larger datasets.");
        }

    });
});

function showModal()
{
    $('#modalForm .modal-content').html("");
    $('#modalForm').modal('show');
}

function getOrderedIds(pimProductIds) {
    return Object.entries(pimProductIds)
        .sort((a, b) => {
            const numA = parseInt(a[0].match(/\d+/)[0], 10);
            const numB = parseInt(b[0].match(/\d+/)[0], 10);
            return numA - numB;
        })
        .map(entry => entry[1]); // Only the value (i.e. the ID)
}

function loadExportImageModal(form, type, pimProductIds)
{
    $('#modalForm .modal-content').load('/pim/product/inventory/' + form, {
        ids: pimProductIds,
        type: type
    });
}

function loadExportDataPdfModal(form, type, pimProductIds, template, name)
{
    $('#modalForm .modal-content').load('/pim/product/inventory/' + form, {
        ids: pimProductIds,
        template: template,
        name: name,
        type: type
    });
}

function getProductIds()
{
    const zgRef = document.querySelector('zing-grid');

    let selectedProducts = zgRef.getSelectedRows();

    let pimProductIds = {};

    Array.from(selectedProducts).forEach((selectedProduct, index) => {
        pimProductIds[selectedProduct.recordIndex] = selectedProduct.id;
    });

    return pimProductIds;
}

function pimDownloadAsset(type)
{

    let pimProductIds = getProductIds();
    let ids = getOrderedIds(pimProductIds);

    let productCount = ids.length;

    if (productCount > 0 && productCount <= maxDefaultDataExport) {

        data = {
            download_type: type,
            "product_id[]": ids
        }

        formSubmit('/pim/product/download/products-as-csv', data);
    } else if (productCount === 0) {
        alert("Please select products.");
    } else {
        alert("This feature only supports up to 1000 records at this time (You selected " + productCount + "). Please use Tags and Categories, along with the 'Export As' option from the main navigation for larger datesets.")
    }

}